export const colors = {
  red: {
    base: '#D32F2F',
    gradient: 'linear-gradient(90deg, #C62828 0%, #E53935 100%)',
    light: '#FFEBEE'
  },
  yellow: {
    base: '#F9A825',
    gradient: 'linear-gradient(90deg, #F57F17 0%, #FFB300 100%)',
    light: '#FFF8E1'
  },
  green: {
    base: '#2E7D32',
    gradient: 'linear-gradient(90deg, #1B5E20 0%, #388E3C 100%)',
    light: '#E8F5E9'
  },
  blue: {
    light: '#E3F2FD',
    base: '#2196F3',
    dark: '#1565C0'
  },
  neutral: {
    bg: '#F8FAFC',
    card: '#FFFFFF',
    bar: '#EEF2F6',
    text: {
      heading: '#1A2A42',
      body: '#334665',
      muted: '#64748B',
      bright: '#0F172A',
    }
  }
}; 